
<div style="display: flex;justify-content: center;margin-top: 30px">
  <div class="container1" style="width: 85%">
    <h2 >Inventario de Aventura</h2>
    <div *ngIf="!loading" class="divButtons" style="justify-content: flex-start">

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>CATEGORÍA</mat-label>
        <mat-select [(value)]="selectCategoria" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let categoria of arrayCategorias" value={{categoria}}>{{categoria}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>ESTADO</mat-label>
        <mat-select [(value)]="selectEstado" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let estado of arrayEstados" value={{estado}}>{{estado}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>TALLA</mat-label>
        <mat-select [(value)]="selectTalla" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let talla of arrayTallas" value={{talla}}>{{talla}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>EQUIPO</mat-label>
        <mat-select [(value)]="selectNombre" (selectionChange)="onSelectionChangedEquipo($event)">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let nombre of arrayNombres" value={{nombre}}>{{nombre}}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>MARCA</mat-label>
        <mat-select [(value)]="selectMarca" (selectionChange)="onSelectionChangedMarca($event)">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let marca of arrayMarcas" value={{marca}}>{{marca}}</mat-option>
        </mat-select>
      </mat-form-field>


      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>MODELO</mat-label>
        <mat-select [(value)]="selectModelo" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let modelo of arrayModelos" value={{modelo}}>{{modelo}}</mat-option>
        </mat-select>
      </mat-form-field>

      

      

<!--       <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>ESTADO</mat-label>
        <mat-select [(value)]="selectEstado" (selectionChange)="applyFilterSelect()">
          <mat-option value={{null}}>No seleccionar</mat-option>
          <mat-option *ngFor="let estado of arrayEstados" value={{estado}}>{{estado}}</mat-option>
        </mat-select>
      </mat-form-field> -->

    </div>

    <div *ngIf="!loading" style="display: flex;justify-content: center;margin-top: 1rem">
      <mat-form-field appearance="outline" class="divInputSearch">
        <mat-label>Filtrar</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Filtrar Búsqueda"/>
      </mat-form-field>
    </div>

    <div *ngIf="loading" class="spinner" >
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>


      <div *ngIf="!loading" class="mat-elevation-z8 overflow">
        <table mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="codigo" >
            <th mat-header-cell *matHeaderCellDef>Codigo</th>
            <td mat-cell *matCellDef="let element">{{ element.codigo }}</td>
          </ng-container>
          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element">
              <mat-icon 
                *ngIf="!element.estado || element.estado === 'DISPONIBLE'" 
                matTooltip="DISPONIBLE" 
                matTooltipPosition="right" 
                style="color: #69BD79;">
                check_circle
              </mat-icon>
              <mat-icon 
                *ngIf="element.estado === 'AVERIADO'" 
                matTooltip="AVERIADO" 
                matTooltipPosition="right" 
                style="color: #FFAE1F;">
                build
              </mat-icon>
              <mat-icon 
                *ngIf="element.estado === 'NO RETORNADO'" 
                [matTooltip]="getTooltipText(element)" 
                matTooltipPosition="right" 
                style="color: #F14646;">
                report_problem
              </mat-icon>
            </td>
          </ng-container>
          
          

          <ng-container matColumnDef="nombre" >
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let element">{{ element.nombreEquipo }}</td>
          </ng-container>

          <ng-container matColumnDef="marca" >
            <th mat-header-cell *matHeaderCellDef>Marca</th>
            <td mat-cell *matCellDef="let element">{{ element.marcaEquipo }}</td>
          </ng-container>

          <ng-container matColumnDef="modelo" >
            <th mat-header-cell *matHeaderCellDef>Modelo</th>
            <td mat-cell *matCellDef="let element">{{ element.modeloEquipo }}</td>
          </ng-container>

          <ng-container matColumnDef="talla" >
            <th mat-header-cell *matHeaderCellDef>Talla</th>
            <td mat-cell *matCellDef="let element">{{ element.tallaEquipo }}</td>
          </ng-container>

          <ng-container matColumnDef="categoria">
            <th mat-header-cell *matHeaderCellDef>Categoria</th>
            <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.categoria }}</td>
          </ng-container>

          <ng-container matColumnDef="valoracion" >
            <th mat-header-cell *matHeaderCellDef>Valoración</th>
            <td mat-cell *matCellDef="let element">{{ element.valoracionEquipo }}</td>
          </ng-container>

          <ng-container matColumnDef="costo" >
            <th mat-header-cell *matHeaderCellDef>Costo</th>
            <td mat-cell *matCellDef="let element">{{ element.costo }}</td>
          </ng-container>

          <ng-container matColumnDef="observaciones" >
            <th mat-header-cell *matHeaderCellDef>Observaciones</th>
            <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.observacionEquipo }}</td>
          </ng-container>

          <ng-container matColumnDef="proveedor" >
            <th mat-header-cell *matHeaderCellDef>Proveedor</th>
            <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.factura?.razonSocial }}</td>
          </ng-container>


          <ng-container matColumnDef="ruc" >
            <th mat-header-cell *matHeaderCellDef>RUC</th>
            <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.factura?.ruc }}</td>
          </ng-container>


          <ng-container matColumnDef="numFactura" >
            <th mat-header-cell *matHeaderCellDef>Número de Factura</th>
            <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.factura?.numFactura }}</td>
          </ng-container>


<!--           <ng-container matColumnDef="estado" >
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td style="max-width: 40px" mat-cell *matCellDef="let element">{{ element.estado }}</td>
          </ng-container> -->


          <ng-container matColumnDef="modificar">
            <th mat-header-cell *matHeaderCellDef> Editar </th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button (click)="openDialogModify(element.id)">
                <mat-icon class="mat-icon-color">edit</mat-icon>
              </button>
            </td>
          </ng-container>

          <ng-container matColumnDef="eliminar">
            <th mat-header-cell *matHeaderCellDef> Eliminar </th>
            <td mat-cell *matCellDef="let element;let i=index" >
              <button mat-icon-button (click)="deleteEquipo(element.id,i)">
                <mat-icon class="mat-icon-color">delete</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" ></tr>

        </table>
      </div>
      <div [hidden]="loading">
        <mat-paginator [pageSizeOptions]="[5, 10, 20]"
                       showFirstLastButtons>
        </mat-paginator>
      </div>
      <div *ngIf="!loading" class="row" style="margin-top: 2%" >
        <button mat-raised-button style="background-color: #e95a1a;color: white" (click)="openDialogAdd()">Agregar Equipo</button>
      </div>



  </div>

</div>




